import React, { useState } from 'react';
import QuizOption from './QuizOption';

const QuizItem = ({quiz:{question, options, id}, index}) => {


    return (
        <div className="quiz">
          <h4 className="question">Quiz {index+1} - {question}</h4>
          <form className="quizOptions">
     {
        options.map((option, index) => <QuizOption key={index} option={option} quizId={id}/>)
     }
          </form>
        </div>
    );
};

export default QuizItem;